import { ConfidenceLevel } from './types';

/**
 * Umbrales de face recognition. Provisorios hasta calibrar con datos reales.
 */
export const FACE_CONFIDENCE_THRESHOLDS = { high: 0.8, medium: 0.6 } as const;

/**
 * Distancia de diarización (menor = mejor) a nivel de confianza.
 * Mismos cortes que el badge de confianza de diarización anterior (30 % / 35 %).
 */
export function distanceToLevel(distance: number): ConfidenceLevel {
  const pct = Math.round(distance * 100);
  if (pct <= 30) {
    return 'high';
  }
  if (pct <= 35) {
    return 'medium';
  }
  return 'low';
}

/** Confidence de face recognition (0..1, mayor = mejor) a nivel de confianza. */
export function confidenceToLevel(confidence: number): ConfidenceLevel {
  if (confidence >= FACE_CONFIDENCE_THRESHOLDS.high) {
    return 'high';
  }
  if (confidence >= FACE_CONFIDENCE_THRESHOLDS.medium) {
    return 'medium';
  }
  return 'low';
}
